import { render, staticRenderFns } from "./ResultNumericalFormula.vue?vue&type=template&id=7ce7bd22&scoped=true&lang=pug&"
import script from "./ResultNumericalFormula.vue?vue&type=script&lang=ts&"
export * from "./ResultNumericalFormula.vue?vue&type=script&lang=ts&"
import style0 from "./ResultNumericalFormula.vue?vue&type=style&index=0&id=7ce7bd22&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce7bd22",
  null
  
)

export default component.exports